import { useNavigationContainerRef } from '@react-navigation/native'
import { Integration } from '@sentry/types'
import { useEffect } from 'react'

/**
 * Hook to register the navigation container with an integration.
 * @param navigationIntegration - The navigation integration instance with a `registerNavigationContainer` method.
 */
const useRegisterSentryNavigationIntegration = (
    navigationIntegration: Integration & {
        registerNavigationContainer: (navigationContainerRef: unknown) => void
    }
): void => {
    const navigationRef = useNavigationContainerRef()

    useEffect(() => {
        if (!navigationRef?.current) return

        navigationIntegration.registerNavigationContainer(navigationRef)
    }, [navigationRef, navigationIntegration])
}

export default useRegisterSentryNavigationIntegration
